import React from 'react';
import { Box, Button, CircularProgress, TextField, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

const DrinkMessageInput = ({
  value,
  disabled,
  loading,
  inputRef,
  onChange,
  onSubmit,
  compact = false,
}) => (
  <Box
    component="form"
    onSubmit={onSubmit}
    sx={{
      mt: { xs: compact ? 0.75 : 1.5, md: 2.5 },
      position: { xs: compact ? 'static' : 'sticky', md: 'static' },
      bottom: { xs: compact ? 'auto' : 8, md: 'auto' },
      zIndex: { xs: 3, md: 'auto' },
      p: { xs: compact ? 0.6 : 1, md: 0 },
      mx: { xs: compact ? 0 : -1, md: 0 },
      borderRadius: { xs: 2.5, md: 0 },
      background: { xs: 'rgba(255,255,255,0.88)', md: 'transparent' },
      backdropFilter: { xs: 'blur(10px)', md: 'none' },
      boxShadow: { xs: compact ? '0 10px 26px rgba(23, 53, 37, 0.10)' : '0 14px 34px rgba(23, 53, 37, 0.12)', md: 'none' },
    }}
  >
    <Typography variant="caption" sx={{ display: compact ? 'none' : 'block', mb: 0.75, fontWeight: 900, color: 'text.secondary' }}>
      أو اكتب إجابتك بطريقتك
    </Typography>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) auto' },
        gap: compact ? 0.65 : 1,
        alignItems: 'stretch',
      }}
    >
      <TextField
        fullWidth
        multiline
        minRows={1}
        maxRows={3}
        inputRef={inputRef}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
        placeholder="اكتب إجابتك هنا..."
        onKeyDown={(event) => {
          if (event.key === 'Enter' && !event.shiftKey && !disabled) {
            event.preventDefault();
            onSubmit(event);
          }
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 2.5,
            backgroundColor: 'background.paper',
            alignItems: 'center',
            minHeight: compact ? 44 : undefined,
          },
          '& textarea': {
            lineHeight: 1.7,
            fontSize: compact ? '0.92rem' : undefined,
          },
        }}
      />
      <Button
        type="submit"
        variant="contained"
        size={compact ? 'medium' : 'large'}
        startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <SendIcon />}
        disabled={disabled}
        fullWidth
        sx={{ px: 3, borderRadius: 2.5, fontWeight: 900, minWidth: { md: 150 }, minHeight: compact ? 42 : undefined }}
      >
        {loading ? 'ثواني...' : 'إرسال'}
      </Button>
    </Box>
  </Box>
);

export default DrinkMessageInput;
